<template>
  <div
    class="m-input-icon m-input-icon--right"
    :class="
      wide
        ? 'm-input-icon--wide'
        : medium
        ? 'm-input-icon--medium'
        : 'm-input-icon--fixed'
    "
  >
    <ui-dropdown
      :placeholder="placeholder"
      :options="options"
      :has-search="hasSearch"
      multi-select
      :key-value-dropdown="keyValueDropdown"
      :value="value"
      light
      :disabled="disabled"
      :all="all"
      get-items-on-select
      header-multi-select
      :multi-values-translation-end="multiValuesTranslationEnd"
      @dropdownSelected="getItems"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'ui-multi-header-dropdown',

  props: {
    value: { type: [String, Number, Array], default: undefined },
    options: { type: Array, default: undefined },
    multiValuesTranslationEnd: { type: String, default: undefined },
    placeholder: { type: String, default: undefined },
    wide: Boolean,
    medium: Boolean,
    disabled: Boolean,
    all: { type: [Boolean, String], default: undefined },
    hasSearch: Boolean,
    keyValueDropdown: Boolean
  },
  methods: {
    getItems(item) {
      this.$emit('dropdownMultiSelected', item)
    }
  }
}
</script>

<style scoped>
.m-input-icon {
  height: 42px;
}
</style>
